import styled from 'styled-components';

export const StepBox = styled.div<any>`
  border-bottom: 1px solid #dce0e9;
  padding: 16px;
  background-color: #fff;
  flex: 1;
  width: 100%;

  &.confirm-mobile {
    padding: 8px 12px;
    border-radius: 4px;
    background: #fff5ce;
    color: var(--Neutral-9, #1d1e20);
    text-align: center;
    font-size: 13px;
    font-weight: 500;
    line-height: 18px;
    margin-bottom: 8px;
  }
`;

export default styled.div`
  margin-left: -8px;
  margin-right: -8px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 20px;
  &.justify-content-between {
    justify-content: space-between;
  }
  &.justify-content-center {
    justify-content: center;
  }
`;
